type PaymentMethod = { brand: string | null; last4: string | null; exp_month?: number | null; exp_year?: number | null } | null;
export type BillingSummaryInput = {
  status: string;
  plan_name: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  payment_method: PaymentMethod;
};

const STATUS_LABELS: Record<string, string> = {
  active: "Active",
  trialing: "Active",
  past_due: "Payment past due",
  unpaid: "Unpaid",
  canceled: "Canceled",
  incomplete: "Incomplete",
  inactive: "No active subscription",
};

export function buildBillingSummary(sub: BillingSummaryInput, seats: { max: number; used: number }) {
  const name = sub.plan_name ?? "";
  const cadence = /annual|year/i.test(name) ? "Annual" : /month/i.test(name) ? "Monthly" : null;
  const brand = sub.payment_method?.brand;
  const last4 = sub.payment_method?.last4;
  return {
    planLabel: sub.plan_name ?? "No plan",
    cadence,
    statusLabel: sub.cancel_at_period_end && sub.status === "active" ? "Cancels at period end" : STATUS_LABELS[sub.status] ?? sub.status,
    dateLabel: sub.cancel_at_period_end ? "Access ends on" : "Renews on",
    date: sub.current_period_end ? new Date(sub.current_period_end).toLocaleDateString(undefined, { dateStyle: "long" }) : null,
    seatsLabel: `${seats.used} of ${seats.max} learner seat${seats.max === 1 ? "" : "s"} in use`,
    paymentLabel: brand && last4 ? `${brand.charAt(0).toUpperCase()}${brand.slice(1)} ending in ${last4}` : null,
  };
}
